import { type FunctionComponent } from 'react';
import { createElement } from 'react';
import { type IconBaseProps } from '@direct-frontend/components';
import cdekIcon from './assets/cdekIcon.react.svg';
import dalliIcon from './assets/dalliIcon.react.svg';
import merchantShipIcon from './assets/merchantShip.react.svg';
import ozonIcon from './assets/ozonIcon.react.svg';
import pecIcon from './assets/pecIcon.react.svg';
import russianPostIcon from './assets/russianPostIcon.react.svg';
import yandexIcon from './assets/yandexIcon.react.svg';
import yandexMarketFboIcon from './assets/yandexMarketFbo.react.svg';
import { type ServiceType } from '../../api/order';

const deliveryServices: Record<ServiceType, FunctionComponent<IconBaseProps> | null> = {
    YANDEX_DELIVERY: yandexIcon,
    CDEK: cdekIcon,
    META_SHIP_RUSSIAN_POST: russianPostIcon,
    META_SHIP_DALLI: dalliIcon,
    META_SHIP_PECOM: pecIcon,
    MERCHANT_SHIP: merchantShipIcon,
    OZON: ozonIcon,
    YANDEX_MARKET_FBO: yandexMarketFboIcon,
    HOLODILNIK: null,
    SELF: null,
};

export interface ServiceTypeIconProps extends IconBaseProps {
    serviceType: ServiceType;
}

export const ServiceTypeIcon: FunctionComponent<ServiceTypeIconProps> = ({ serviceType, size }) => {
    if (!deliveryServices[serviceType]) {
        return null;
    }

    return createElement(deliveryServices[serviceType], { width: size, height: size });
};
